// Lightweight localStorage queue for the Help > Report a Problem feature.
// Uses its own store so it doesn't collide with inspection sync.

const KEY = "hag_app_issues_pending";

function readAll() {
  try { return JSON.parse(localStorage.getItem(KEY) || "[]"); } catch { return []; }
}
function writeAll(list) { localStorage.setItem(KEY, JSON.stringify(list)); }

export function queueAppIssue(rec) {
  const list = readAll();
  list.push({ ...rec, queued_at: new Date().toISOString(), id: `local-${Date.now()}-${Math.random().toString(36).slice(2, 8)}` });
  writeAll(list);
}

export function listPendingAppIssues() { return readAll(); }

export function removePendingAppIssue(id) {
  writeAll(readAll().filter((r) => r.id !== id));
}

// Send anything currently queued. `api` is the axios instance.
export async function syncAppIssues(api) {
  if (!navigator.onLine) return { synced: 0, total: 0 };
  const list = readAll();
  let synced = 0;
  for (const rec of list) {
    try {
      await api.post("/escalations/app-issue", {
        description: rec.description,
        screenshot_data_url: rec.screenshot_data_url || null,
        client_queued_at: rec.queued_at,
        lang: rec.lang,
      });
      removePendingAppIssue(rec.id);
      synced += 1;
    } catch (e) {
      console.debug("[appIssues] sync retry pending for", rec.id, "-", e?.message);
    }
  }
  return { synced, total: list.length };
}
